import { findAllRoles } from '@src/main/modules/roles/application/find-all-roles.usecase';
import { RoleRepository } from '@src/main/modules/roles/domain/role.repository';
import { createRoleHttpRepository } from '@src/main/modules/roles/infrastructure/RoleHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useRoles = () => {
  const { user } = useAuth();
  const [repository, setRepository] = useState<RoleRepository | null>(null);

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  useEffect(() => {
    if (user?.token) {
      const repo = createRoleHttpRepository(tokenProvider);
      setRepository(repo);
    } else {
      setRepository(null);
    }
  }, [user?.token, tokenProvider]);

  const queryResult = useQuery({
    queryKey: ['role'],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await findAllRoles(repository);
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });

  return { ...queryResult, repository };
};
